import React from 'react';

interface IProgressCircle {
    progress: number;
    size: number;
    strokeWidth: number;
    strokeColour?: string;
    backgroundColour?: string;
}

export default function ProgressCircle(props: IProgressCircle) {
  const { progress, size, strokeWidth, strokeColour = "#2D4675", backgroundColour = "#EAECF0" } = props;
  const center = size / 2;
  const radius = center - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;

  // Calculate the offset to show progress
  const offset = circumference - (progress > 99 ? 99 : progress / 100) * circumference;

  return (
    <svg width={size} height={size}>
      {/* Background Circle */}
      <circle
        stroke={backgroundColour}
        fill="transparent"
        strokeWidth={strokeWidth}
        r={radius}
        cx={center}
        cy={center}
      />
      {/* Progress Circle */}
      <circle
        stroke={strokeColour}
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        r={radius}
        cx={center}
        cy={center}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        style={{ transition: 'stroke-dashoffset 0.3s ease' }}
        transform={`rotate(-90 ${center} ${center})`} // Start from the top
      />
      {/* Text Label */}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy=".3em"
        fontSize="14px"
        fill="#333"
      >
        {`${progress}%`}
      </text>
    </svg>
  );
}